import { ActionType, ComponentType } from '@cbhq/client-analytics';

import type { Track } from '../types';

import { addIdCaptureRumAction } from './rum';

async function checkForCamera(track: Track): Promise<void> {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();

    const videoDevices = devices.filter((device) => device.kind === 'videoinput');

    if (videoDevices.length === 0) {
      track('camera_device_not_found', {
        componentType: ComponentType.content_script,
        action: ActionType.measurement,
        error: 'Camera device not found in the device list',
      });
      addIdCaptureRumAction('camera_device_not_found', {
        error: 'no_video_inputs',
      });
    }
  } catch (error) {
    track('camera_device_not_found', {
      componentType: ComponentType.content_script,
      action: ActionType.measurement,
      error: error instanceof Error ? error.message : 'Camera devices not accessible',
    });
    addIdCaptureRumAction('camera_device_not_found', {
      error: 'enumerate_failed',
    });
  }
}

export { checkForCamera };
